import styled from 'styled-components'

export const LogoImg = styled.img`
    width: 6em;
`

export const SignupButton = styled.button`
    cursor: pointer;
    margin: 1em;
    padding: 1em;
    padding-left: 2em;
    padding-right: 2em;
    color: #000000;
    background-color: rgba(255, 255, 255, 0.88);
    border: none;
    border-radius: 300px;
    &:hover {
        opacity: 0.8;
    }
    font-family: 'proxima-nova', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1.8em;
    font-size: 1rem;
    font-family: proxima-nova;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0em;
    text-transform: none;
    line-height: 1.2em;
    font-size: 1.1rem;
`

export const LegalFooter = styled.p`
    width: 100%;
    padding: 5px;
    text-align: center;
    color: #ffffff;
`

export const Background = styled.div`
    width: 100%;
    background-image: url('https://images.squarespace-cdn.com/content/v1/61309b7dbcbb7f22b7fe1af3/b84cbaf2-4387-4934-824d-1413a6219e89/Gradient_1.png');
    background-size: cover;
    text-align: center;
    min-height: 100vh;
    padding: 5vh 0 1.5em;
`

export const CenteredDiv = styled.div`
  width: 25%;
  margin: auto;
  @media screen and (max-width: 1470px) {
    width: 45%;
  }
  @media screen and (max-width: 1250px) {
    width: 65%;
  }
}
`

export const Header = styled.div`
    color: #ffffff;
`

export const Form = styled.div`
    color: #ffffff;
`

export const FormInput = styled.div`
    color: #000000;
    background: #ffffff;
`
